import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../Context/AuthContext'
import Loading from '../../../Common/Components/Loading'

interface AuthGuardProps {
  children: React.ReactNode
}

/**
 * 認証ガードコンポーネント
 * 
 * 認証が必要なページをラップし、未認証の場合はログインページにリダイレクトする
 */
const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  // 認証状態を確認中はローディング表示
  if (isLoading) {
    return <Loading />
  }

  // 未認証の場合はログインページにリダイレクト
  // 現在のパスを state に保存して、ログイン後に元のページに戻れるようにする
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}

export default AuthGuard
